<template>
  <v-toolbar :clipped-left="clipped" app color="primary" fixed height="60">
    <v-toolbar-side-icon  @click.stop="leftMenuToggle" v-if="leftmenu.enabled"> <v-icon color="white">menu</v-icon></v-toolbar-side-icon>
    <v-toolbar-title class="hidden-sm-and-down">
      <v-avatar  size="35" >
        <v-img :src="logo" alt="logo" aspect-ratio="1"  contain></v-img>
      </v-avatar>

      <span class="white--text " v-if="maintoolbar.title">
        {{ maintoolbar.title }}
      </span>
      <span class="white--text " v-else>
          <router-link class="white--text " style="text-decoration: none;" :to="{ name: 'Main'}">Система учета деятельности диссертационных советов</router-link>
      </span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn flat>
      <a href="mailto:support@muctr.ru" class=" white--text"  style="text-decoration: none;">СООБЩИТЬ ОБ ОШИБКЕ</a>
    </v-btn>
    <v-menu bot offset-y v-if="user.isAuthenticated">
      <v-btn class="white--text " flat slot="activator">

        <v-avatar size="30">
          <img :src="NotAvatar" alt="avatar"
            v-if="maintoolbar.userAvatar== null ">
          <v-img :src="maintoolbar.userAvatar"
                  v-else></v-img>
        </v-avatar>
        <span v-if="user.isAuthenticated" class="pa-1" >
            {{ user.username }}
        </span>
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile :key="i" v-for="(item, i) in maintoolbar.userActions">
          <v-list-tile-title>
            <a :href="item.url"
            target="_blank">
              {{ item.title }}
            </a>
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-title @click="logout" style="text-decoration: underline; cursor:pointer">
            Выйти
          </v-list-tile-title>
        </v-list-tile>
      </v-list>

    </v-menu>
    <!--КНОПКА АВТОРИЗАЦИИ : КОНЕЦ-->

    <v-toolbar-items v-else>

      <v-btn  @click="routerLogin"  class="white--text " flat mr-5>
        Войти
      </v-btn>
    </v-toolbar-items>

  </v-toolbar>
</template>

<script>
  import {mapState} from 'vuex'
  import logo from "@/assets/logo.png";
  import NotAvatar from "@/assets/NotAvatar.png";
  import {makeGetRequest, makeProfileUrl} from "../../helper";
  import urls from "../petition/urlsU";

  export default {
    name: "topmenu",
    data() {
      return {
        clipped: true,
        drawer: true,
        logo: logo,
        NotAvatar: NotAvatar,
      }
    },
    computed: {
      ...mapState({
        leftmenu: state => state.leftmenu,
        maintoolbar: state => state.maintoolbar,
        user: state => state.user,
      }),

    },

    methods: {
      routerLogin(){
          if (this.$route.query.redirect !== undefined)
            document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=${document.location.origin}${this.$route.query.redirect}`;
          else
              document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=${document.location.origin}`;
      },
      routerPath(item){

        if (item.router)
          this.$router.push({path: item.router});
        else if (item.url){
            window.open(item.url,'_blank');
        } else{
          this.$router.push({name: item.name});
        }
      },
      dispatchRouter(item) {
        if (item.router)
          this.$router.push({name: item.router});
      },
      leftMenuToggle() {
        this.$store.commit('leftmenu/toggleVisible');
      },
      logout: function () {
        this.$store.commit('urls/clearUrls');
        this.$store.commit('leftmenu/dissable');
        this.$store.commit('leftmenu/replaceItems', []);
        // console.log('here');
        this.$store.dispatch('user/AUTH_LOGOUT')
          .then(() => {
            this.$router.push({name: 'Main'})
          });
      },
    },
    created() {

    },
    beforeRouteUpdate(to, from, next) {

    }
  }
</script>

<style scoped>

</style>
